import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import { Creators as FileActions, Types as FileTypes } from 'store/ducks/File';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* exportFile({ payload }) {
  try {
    const { status, data } = yield call(api.post, '/exports', payload, {
      responseType: 'blob',
    });
    if (status === 200) {
      yield put(FileActions.exportFileSuccess(data));
    } else {
      Sentry.captureMessage('exportFile failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(FileActions.exportFileError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(FileActions.exportFileError());
  }
}

function* importFile({ payload }) {
  try {
    const { status, data } = yield call(
      api.post,
      '/imports/generation',
      payload,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    if (status === 200) {
      yield put(FileActions.importFileSuccess(data));
    } else {
      Sentry.captureMessage('importFile failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(FileActions.importFileError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(FileActions.importFileError());
  }
}

function* exportFileWatcher() {
  yield takeLatest(FileTypes.EXPORT_FILE_REQUEST, exportFile);
}

function* importFileWatcher() {
  yield takeLatest(FileTypes.IMPORT_FILE_REQUEST, importFile);
}

export default function* rootSaga() {
  yield all([fork(exportFileWatcher), fork(importFileWatcher)]);
}
